// language.ts — content-language design (2026-08-22, THI-119) §Data/§Dashboard/"Telling the
// agent". English display names for the small set of content languages `detectContentLanguage`
// (apps/api/src/crawler/language.ts) can return, shared by the dashboard (Task 2, source chip
// + detail header) and the engine's system-prompt block (Task 3) — one map so "Vietnamese"
// reads the same everywhere instead of two independently hand-written copies drifting apart.
const LANGUAGE_NAMES: Record<string, string> = {
  en: 'English',
  vi: 'Vietnamese',
  ja: 'Japanese',
  ko: 'Korean',
  zh: 'Chinese',
  fr: 'French',
  de: 'German',
  es: 'Spanish',
  pt: 'Portuguese',
  it: 'Italian',
  nl: 'Dutch',
  pl: 'Polish',
  tr: 'Turkish',
  id: 'Indonesian',
  hi: 'Hindi',
  th: 'Thai',
  ru: 'Russian',
  ar: 'Arabic',
};

/** English display name for a lowercase ISO-639-1 code (`Document.language`, `languageMix`/
 * `contentLanguages` roll-ups). A code outside the map (an ISO-639-1 language
 * `detectContentLanguage`/tinyld can genuinely return that just isn't in this shortlist yet)
 * falls back to the lowercased code itself rather than throwing or guessing — this is a
 * display convenience, not a validator. Fix round 1 (NIT, 2026-08-22): the fallback used to
 * upper-case the code (`languageName('sw')` → "SW"), which reads as a rendering bug next to
 * every mapped name being a real word ("Swahili"); lowercasing it instead makes an unmapped
 * code read as an ordinary (if unfamiliar) word — "sw" — inside a sentence like "it is
 * written in sw." Case-insensitive on input; every writer stores lowercase, but a caller
 * shouldn't have to know that. */
export function languageName(code: string): string {
  return LANGUAGE_NAMES[code.toLowerCase()] ?? code.toLowerCase();
}
